import { css, html } from 'react-strict-dom';

import { color } from '../constants/color.css';

type Props = {
  width?: number | string;
  height?: number | string;
  circle?: boolean;
  radius?: number;
  aspectRatio?: number;
  style?: css.StyleXStyles;
};

/** A horizontal highlight sweep, the same treatment as the dcg-js skeleton. */
const shimmer = css.keyframes({
  from: { backgroundPosition: '100% 0' },
  to: { backgroundPosition: '-100% 0' },
});

export default function Skeleton({
  width = '100%',
  height = '100%',
  circle,
  radius,
  aspectRatio,
  style,
}: Props) {
  return (
    <html.div
      aria-hidden
      style={[
        styles.base,
        styles.shimmer,
        circle && styles.circle,
        radius != null && styles.radius(radius),
        aspectRatio != null && styles.aspectRatio(aspectRatio),
        styles.width(width),
        styles.height(height),
        style,
      ]}
    />
  );
}

const styles = css.create({
  base: {
    backgroundColor: color.neutral15,
    backgroundImage: `linear-gradient(90deg, transparent 0%, ${color.neutral10} 50%, transparent 100%)`,
    backgroundSize: '200% 100%',
    backgroundRepeat: 'no-repeat',
    borderRadius: 4,
  },
  shimmer: {
    animationName: shimmer,
    animationDuration: '1.6s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    '@media (prefers-reduced-motion: reduce)': {
      animationName: 'none',
      backgroundImage: 'none',
    },
  },
  circle: {
    borderRadius: '50%',
  },
  radius: (value: number) => ({
    borderRadius: value,
  }),
  aspectRatio: (value: number) => ({
    aspectRatio: value,
  }),
  width: (value: number | string) => ({
    width: value,
  }),
  height: (value: number | string) => ({
    height: value,
  }),
});
